import React from 'react';
import * as ROUTES from '../../../constants/routes';
import PricingPersonaHero from './PricingPersonaHero';
import PricingTwoCardGrid from './PricingTwoCardGrid';
import PricingFeatureTable from './PricingFeatureTable';

const ROWS = [
    { title: '🔍 Free Triaging', freeItems: ['Portfolio dashboard', 'InvestorMatch application', 'Fit Report vs criteria', 'Investment Readiness Report', 'Workflow Manager', 'Research Reports (5 types)', 'Data Repository & Business Audit access', 'AnyList & ResearchAid further diligence', 'Match rejected applicants with other investors', 'Agentic & phone support'] },
    { title: '📈 Portfolio — Growth', paidItems: ['Growth Readiness Checklist', '100-Day Value Growth Plan', '20× Healthboost Modules', 'Shared data repository', 'Quarterly portfolio reviews', 'Portfolio Benchmarking'] },
    { title: '🏁 Portfolio — Exit', paidItems: ['Exit Readiness Checklist', 'Foundational & Value Diligence Packs', 'AnyList & ResearchAid builders', "Draft Warranty Disclosures & Directors' Questionnaires"] },
];

const PricingInvestorsPanel = () => (
    <div role="tabpanel">
        <PricingPersonaHero
            eyebrow="For Investors"
            dotColor="#1F8A5B"
            title="Free to triage. Powerful for your portfolio."
            subtitle="Your investor account is always free. Onboard portfolio companies at 20% off Pro."
            primaryCta={{ text: 'Create investor account', href: ROUTES.REGISTER }}
            secondaryCta={{ text: 'Learn more ↓', href: '#investors-included' }}
        />

        <PricingTwoCardGrid
            free={{ label: 'Free — Your Investor Account', amount: '£0', sub: 'free always', text: 'Full applicant triaging, diligence reports & portfolio dashboard — at zero cost.', cta: { text: 'Get started free', href: ROUTES.REGISTER } }}
            paid={{ label: 'Portfolio Pro', amount: '£66.67', sub: '/ mo · £800/yr · code INVESTOR20', text: 'Onboard a portfolio company to the full Pro toolkit.', badge: 'Per portfolio company', cta: { text: 'Add a company', href: ROUTES.REGISTER } }}
        />

        <div id="investors-included">
            <PricingFeatureTable
                freeColLabel="Free — you"
                paidColLabel="Portfolio Pro / company"
                freeSummary="All free tools + full Company Pro per investee"
                rows={ROWS}
                footnote="* Portfolio Pro (£800/yr per company) via your investor dashboard. Code INVESTOR20 at checkout."
            />
        </div>
    </div>
);

export default PricingInvestorsPanel;
